<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">我的班级</p>
					<router-link to="/add_class" class="tc cl_white class_add_btn">加入班级</router-link>
				</div>
				<div class="my_class_cont flex mat30">
					<div class="my_class_list radius8 bs flex mab30" v-for="(item,index) in list" :key="index">
						<img src="../../../static/my_class_icon.png" />
						<div class="">
							<p class="f20px cl_dark">{{item.name}}<span class="f16px cl_gray">（{{item.class_type == "normal" ? "行政班" : "教学班"}}）</span></p>
							<p class="f16px cl_gray mat10">班主任：{{item.master_user_name}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	
	export default {
		name: 'my_class',
		components: {
			studentNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 2,
					listCur: 0,
					open: 0,
				},
				list: [],
			}
		},
		created() {
			
		},
		mounted() {
			this.getList();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getList () {
				this.$get("/api/student/get_my_class_list",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					this.list = res.data;
				});
			},
		},
	}
</script>

<style>
</style>
